export default __webpack_public_path__ + "static/media/RadioButtonNotSelected.cfdde96e.svg";